<template>
  <b-container fluid>
    <h2>Data Archives</h2>
    <p>This page displays all data archived by Auroras.live. Each file is a JSON file containing all data for the given month and year. Clicking on a link will open it in a new window. Right-click and click Save As to download the file to your device.</p>
    <p>Note that some data may be missing due to factors outside of this site's control</p>
    <b-table :fields="['type', 'month / year', 'download']" :items="response" small hover striped>
      <template slot="month / year" slot-scope="data">
        {{ DateTime.fromFormat(data.item.month.toString(), 'L').toFormat('MMMM') }} {{ data.item.year }}
      </template>
      <template slot="download" slot-scope="data">
        <b-button :href="data.item.url" size="sm" target="_blank"><open-in-new-icon /> Open File</b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'
import {
  get
} from 'lodash'
import {
  DateTime
} from 'luxon'

import axios from 'axios'

export default {
  name: 'kp27day',
  components: {
    OpenInNewIcon
  },
  mounted() {
    axios.post('https://v2.api.auroras.live/', {
        "modules": ['archive'],
        "format": {
          "date": {
            "tz": (window.localStorage.getItem('auroraslive-tz') || (new Date).getTimezoneOffset()),
            "format": "D M jS"
          },
        }
      }, {
        withCredentials: true // Use this so cookies are properly set
      })
      .then(function(response) {
        this.response = response.data["archive"]
      }.bind(this))
      .catch(function() {
        this.error = "There was an error loading the data. The error returned was " + this.error
      }.bind(this))
      .then(function() {
        this.appdata.loading = false
      }.bind(this))
  },
  methods: {
    track () {
      this.$ga.page(this.$route.path)
    }
  },
  data() {
    return {
      response: [],
      selectedImage: '',
      ld: {
        get: _.get
      },
      DateTime: DateTime,
      appdata: {
        loading: false
      }
    }
  }
}
</script>
<style>
  .scroll {
    height: 85vh;
    overflow-y: scroll;
  }
</style>
